import { Box, Divider, Card as MuiCard, Stack, SxProps, Typography } from "@mui/material";
import { ReactNode } from "react";

const COMMON_SX: SxProps = {
  px: 2,
};

interface CardProps {
  title?: ReactNode;
  startIcon?: ReactNode;
  children?: ReactNode;
}

const Card = ({ title, startIcon, children }: CardProps) => {
  return (
    <MuiCard sx={{ px: 0 }}>
      {title && (
        <>
          <Stack
            direction='row'
            spacing={1}
            useFlexGap
            sx={{ ...COMMON_SX }}>
            {startIcon}
            <Typography
              variant='h20'
              sx={{ fontWeight: 500 }}>
              {title}
            </Typography>
          </Stack>
          <Divider sx={{ mt: 2, mb: 2.5 }} />
        </>
      )}
      <Box sx={{ ...COMMON_SX }}>{children}</Box>
    </MuiCard>
  );
};

export default Card;
